module.exports = __webpack_public_path__ + "img/coininfo-bg.4e53f70e.png";